module.exports = __webpack_public_path__ + "img/svg/background-contact-aboput-us.c93d710891c7864c31bda391a4cbc83e.svg";